// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_description{font-weight:300;margin:36px 0 12px 0;font-size:16px;line-height:24px;color:#8c8c8c;text-align:center;max-width:340px}.modal_link{text-align:center}.code_is_gone{font-weight:300;display:flex;align-self:flex-end;font-size:16px;line-height:24px;color:#bfbfbf}.cursor{cursor:pointer}.timer_run{font-weight:300;font-size:14px}", ""]);
// Exports
module.exports = exports;
